import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="7.05mm"
    height={21.505}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21891 17667"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#2b2a29;stroke-width:776.261}.fil1{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974319848384">
        <path
          d="M388 8285h21114v2449H388z"
          className="fil1-bg stroke1"
          style={{
            fill: "none",
            strokeWidth: 776.261,
          }}
        />
        <path
          d="M388 8285h479v2449H388zM21024 8285h478v2449h-478z"
          className="fil1"
        />
        <path
          d="M388 9344h21114v330H388zM11227 17279h1c133 0 242-109 242-243v-2036c0-134-109-243-242-243h-1c-133 0-242 109-242 243v2036c0 134 109 243 242 243zM3003 15110c95 94 249 94 343 0l1440-1440c95-94 95-248 0-343-94-95-248-95-342 0l-1441 1440c-94 95-94 248 0 343zM7055 16650c126 45 265-20 311-145l697-1915c45-125-20-265-145-310-126-46-265 19-311 145l-696 1913c-46 126 19 266 144 312zM18887 15110c-94 94-248 94-343 0l-1440-1440c-94-94-94-248 0-343 95-95 249-95 343 0l1440 1440c95 95 95 248 0 343zM14835 16650c-125 45-265-20-311-145l-696-1915c-46-125 19-265 144-310h1c125-46 265 19 310 145l697 1913c46 126-20 266-145 312zM10663 388c-133 0-242 109-242 243v2036c0 134 109 242 242 242 134 0 243-108 243-242V631c0-134-109-243-243-243zM18887 2557c-94-95-248-95-343 0l-1440 1440c-94 94-94 249 0 343 95 95 249 95 343 0l1440-1440c95-95 95-249 0-343zM14835 1018v-1c-125-45-265 20-311 146l-696 1913c-46 126 19 265 144 311h1c125 46 265-20 310-145l697-1914c46-125-20-265-145-310zM3003 2557c95-95 249-95 343 0l1440 1440c95 94 95 249 0 343-94 95-248 95-342 0L3003 2900c-94-95-94-249 0-343zM7055 1018v-1c126-45 265 20 311 146l697 1913c45 126-20 265-145 311-126 46-265-20-311-145l-696-1914c-46-125 19-265 144-310z"
          className="fil1"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
